/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  APIResponseBase,
  GetStats200Response,
  GetStatsBilling200Response,
  GetStatsMitm200Response,
} from '../models';
import {
    APIResponseBaseFromJSON,
    APIResponseBaseToJSON,
    GetStats200ResponseFromJSON,
    GetStats200ResponseToJSON,
    GetStatsBilling200ResponseFromJSON,
    GetStatsBilling200ResponseToJSON,
    GetStatsMitm200ResponseFromJSON,
    GetStatsMitm200ResponseToJSON,
} from '../models';

export interface GetStatsRequest {
    slashIDOrgID: string;
    bin: GetStatsBinEnum;
    start: Date;
    end?: Date;
}

export interface GetStatsBillingRequest {
    slashIDOrgID: string;
    start: Date;
    end?: Date;
}

export interface GetStatsMitmRequest {
    slashIDOrgID: string;
    start: Date;
    end?: Date;
}

/**
 * 
 */
export class StatsApi extends runtime.BaseAPI {

    /**
     * This endpoint is private and meant for console metrics. 
     * Get event-based statistics about organization activity
     */
    async getStatsRaw(requestParameters: GetStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetStats200Response>> {
        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) {
            throw new runtime.RequiredError('slashIDOrgID','Required parameter requestParameters.slashIDOrgID was null or undefined when calling getStats.');
        }

        if (requestParameters.bin === null || requestParameters.bin === undefined) {
            throw new runtime.RequiredError('bin','Required parameter requestParameters.bin was null or undefined when calling getStats.');
        }

        if (requestParameters.start === null || requestParameters.start === undefined) {
            throw new runtime.RequiredError('start','Required parameter requestParameters.start was null or undefined when calling getStats.');
        }

        const queryParameters: any = {};

        if (requestParameters.bin !== undefined) {
            queryParameters['bin'] = requestParameters.bin;
        }

        if (requestParameters.start !== undefined) {
            queryParameters['start'] = (requestParameters.start as any).toISOString();
        }

        if (requestParameters.end !== undefined) {
            queryParameters['end'] = (requestParameters.end as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters.slashIDOrgID);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stats`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetStats200ResponseFromJSON(jsonValue));
    }

    /**
     * This endpoint is private and meant for console metrics. 
     * Get event-based statistics about organization activity
     */
    async getStats(requestParameters: GetStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetStats200Response> {
        const response = await this.getStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * This endpoint is private and meant for console metrics. 
     * Get event-based statistics about billable organization activity. Aggregated stats are bound at the 1st day of each month
     */
    async getStatsBillingRaw(requestParameters: GetStatsBillingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetStatsBilling200Response>> {
        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) {
            throw new runtime.RequiredError('slashIDOrgID','Required parameter requestParameters.slashIDOrgID was null or undefined when calling getStatsBilling.');
        }

        if (requestParameters.start === null || requestParameters.start === undefined) {
            throw new runtime.RequiredError('start','Required parameter requestParameters.start was null or undefined when calling getStatsBilling.');
        }

        const queryParameters: any = {};

        if (requestParameters.start !== undefined) {
            queryParameters['start'] = (requestParameters.start as any).toISOString();
        }

        if (requestParameters.end !== undefined) {
            queryParameters['end'] = (requestParameters.end as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters.slashIDOrgID);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stats/billing`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetStatsBilling200ResponseFromJSON(jsonValue));
    }

    /**
     * This endpoint is private and meant for console metrics. 
     * Get event-based statistics about billable organization activity. Aggregated stats are bound at the 1st day of each month
     */
    async getStatsBilling(requestParameters: GetStatsBillingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetStatsBilling200Response> {
        const response = await this.getStatsBillingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * This endpoint is private and meant for console metrics. 
     * Get event-based statistics about MITM detections, grouped by proxied domain.
     */
    async getStatsMitmRaw(requestParameters: GetStatsMitmRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetStatsMitm200Response>> {
        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) {
            throw new runtime.RequiredError('slashIDOrgID','Required parameter requestParameters.slashIDOrgID was null or undefined when calling getStatsMitm.');
        }

        if (requestParameters.start === null || requestParameters.start === undefined) {
            throw new runtime.RequiredError('start','Required parameter requestParameters.start was null or undefined when calling getStatsMitm.');
        }

        const queryParameters: any = {};

        if (requestParameters.start !== undefined) {
            queryParameters['start'] = (requestParameters.start as any).toISOString();
        }

        if (requestParameters.end !== undefined) {
            queryParameters['end'] = (requestParameters.end as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters.slashIDOrgID);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stats/mitm`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetStatsMitm200ResponseFromJSON(jsonValue));
    }

    /**
     * This endpoint is private and meant for console metrics. 
     * Get event-based statistics about MITM detections, grouped by proxied domain.
     */
    async getStatsMitm(requestParameters: GetStatsMitmRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetStatsMitm200Response> {
        const response = await this.getStatsMitmRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetStatsBinEnum = {
    NUMBER_60: 60,
    NUMBER_1440: 1440
} as const;
export type GetStatsBinEnum = typeof GetStatsBinEnum[keyof typeof GetStatsBinEnum];
